import { render, staticRenderFns } from "./RequestCard.vue?vue&type=template&id=bc35cec6&scoped=true&"
import script from "./RequestCard.vue?vue&type=script&lang=ts&"
export * from "./RequestCard.vue?vue&type=script&lang=ts&"
import style0 from "./RequestCard.vue?vue&type=style&index=0&id=bc35cec6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc35cec6",
  null
  
)

export default component.exports